import styled from 'styled-components';
import { Flex } from '../../components';
import { getColor } from '../../styles/mixins';

export const DiagramNotFoundBody = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
`;

export const DisplayNotFoundText = styled(Flex)`
  font-size: 20px;
  width: 512px;
  font-weight: 500;
  text-align: center;
  margin-top: 32px;
  color: ${getColor('gray', 500)};
`;
